import * as styles from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import image5 from './images/5.jpg'
import image6 from './images/6.jpg'
import image7 from './images/7.jpg'

export const DesktopHero: React.FC = () => {
  return (
    <div className="hidden lg:block flex-1 sticky top-0 h-screen w-5/12">
      <div className="absolute inset-0 w-full h-ful">
        <img className={styles.image} src={image7} style={{ animationDelay: '30s' }} />
        <img className={styles.image} src={image6} style={{ animationDelay: '25s' }} />
        <img className={styles.image} src={image5} style={{ animationDelay: '20s' }} />
        <img className={styles.image} src={image4} style={{ animationDelay: '15s' }} />
        <img className={styles.image} src={image3} style={{ animationDelay: '10s' }} />
        <img className={styles.image} src={image2} style={{ animationDelay: '5s' }} />
        <img className={styles.image} src={image1} style={{ animationDelay: '0s' }} />
      </div>
      <div className="absolute inset-0 bg-black/15" />
      <p
        className="absolute left-12 bottom-16 text-white text-[18px] font-semibold tracking-widest"
        style={{ textShadow: '0 1px 8px rgba(197, 197, 197, 0.05)' }}
      >
        同じ花、なのに毎回違う。
      </p>
    </div>
  )
}
